// extracted by mini-css-extract-plugin
module.exports = {"ProfileDashboard":"ProfileDashboard_ProfileDashboard__3hBd4","ProfileDashboardParent":"ProfileDashboard_ProfileDashboardParent__CfIlq"};